import React from 'react';
import App from './App';
import './index.scss';
import '../src/assets/styles/global.scss';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { store } from './app/store';
import { ToastProvider } from './components/ui/Toast/ToastProvider';
import { NotifierBridge } from './shared/lib/NotifierBridge'
import { SessionGate } from './app/SessionGate';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <ToastProvider>
          <NotifierBridge />
          <SessionGate>
            <App />
          </SessionGate>
        </ToastProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
);